import {mySelf} from "./actions/authActions";
import {actions} from "./reducers/auth";
import history from "./config/history";
import store from "./config/store";
import {Routes} from "./config/routes";
import {getUserFunctionalities} from "./actions/boCoreActions";
import moment from "moment";
import {updateUserLocale} from "./actions/authActions";
import Utils from "./Utils";

export default interface UserPreference {
    locale: {value: string, label: string};
}

export enum UserRoles {
    SYSTEM_ADMIN = 'admin',
    USER = 'user'
}

export default class AuthUtils {
    private static readonly PREFERENCE_MISSING_VALUE = "n/a";
    private static readonly SESSION_STORAGE_ACCESS_TOKEN = "access_token";
    private static readonly SESSION_STORAGE_REFRESH_TOKEN = "refresh_token";
    static user = null;

    static mySelfRequest = (userPreference: UserPreference) => {
        mySelf(false)
            .then(response => {
                if (!location.pathname.startsWith(process.env.ENV_PREFIX)) {
                    history.push(`${process.env.ENV_PREFIX}${location.pathname}`);
                } else if (response.data) {
                    AuthUtils.updateUserPreferences(response.data, userPreference);
                }
                store.dispatch({type: actions.SET_ROLES, payload: response.data.roles});
                AuthUtils.user = response.data;

                getUserFunctionalities()
                    .then((res) => {
                        let uiRoutesArr = [];
                        res.data.data.forEach(functionality => {
                            uiRoutesArr = uiRoutesArr.concat(functionality.uiRoutes);
                        })
                        if (response.data.mta || uiRoutesArr.includes(Routes.ALL_ROUTES) || AuthUtils.user.systemAdministrator) {
                            let uiRoutes =  Object.keys(Routes).map(route => {
                                return Routes[route]
                            });
                            if (!response.data.mta) {
                                uiRoutes = uiRoutes.filter(route => route !== Routes.TENANT_MANAGEMENT &&
                                    route !== Routes.DATA_VIEW_CONFIG && route !== Routes.BUSINESS_OBJECTS)
                            }
                            store.dispatch({type: actions.SET_UI_ROUTES, payload: Array.from(uiRoutes)});
                            store.dispatch({type: actions.AUTH_USER, payload: response.data});
                        } else {
                            const uniqueRoutes = new Set(uiRoutesArr);
                            store.dispatch({type: actions.SET_UI_ROUTES, payload: Array.from(uniqueRoutes)});
                            store.dispatch({type: actions.AUTH_USER, payload: response.data});
                        }
                    })
                    .catch(() => {
                        store.dispatch({type: actions.SET_UI_ROUTES, payload: []});
                        store.dispatch({type: actions.AUTH_USER, payload: response.data});
                    })
            })
            .catch(() => {
                AuthUtils.clearSessionStorageTokens();
                history.push(`${process.env.ENV_PREFIX}/login`);
            });
    };

    static updateUserPreferences = (myselfResponse: any, currentUserPreference: UserPreference) => {
        AuthUtils.updateUserLocale(myselfResponse.locale, currentUserPreference);
    };

    static setSessionStorageTokens = (accessToken: string, refreshToken: string) => {
        sessionStorage.setItem(AuthUtils.SESSION_STORAGE_ACCESS_TOKEN, accessToken);
        sessionStorage.setItem(AuthUtils.SESSION_STORAGE_REFRESH_TOKEN, refreshToken);
    };

    static clearSessionStorageTokens = () => {
        sessionStorage.removeItem(AuthUtils.SESSION_STORAGE_ACCESS_TOKEN);
        sessionStorage.removeItem(AuthUtils.SESSION_STORAGE_REFRESH_TOKEN);
    };

    static getAccessToken = () => {
        return sessionStorage.getItem(AuthUtils.SESSION_STORAGE_ACCESS_TOKEN);
    };

    static getRefreshToken = () => {
        return sessionStorage.getItem(AuthUtils.SESSION_STORAGE_REFRESH_TOKEN);
    };

    static isRefreshTokenPresent = (): boolean => {
        if (sessionStorage.getItem(AuthUtils.SESSION_STORAGE_REFRESH_TOKEN)) {
            return true;
        }
        return false;
    };

    static isAccessTokenPresent = (): boolean => {
        if (sessionStorage.getItem(AuthUtils.SESSION_STORAGE_ACCESS_TOKEN)) {
            return true;
        }
        return false;
    };

    static objectToEncodedRequestBody = (object: Object): string => {
        let formBody = [];
        for (var property in object) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(object[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        return formBody.join("&");
    };

    static updateUserLocale = (myselfLocale: any, currentUserPreference: UserPreference) => {
        const preferredLocale = AuthUtils.retrievePreferredLocale(myselfLocale);
        if (preferredLocale && preferredLocale !== currentUserPreference.locale.value) {
            store.dispatch({
                type: actions.SET_APPLICATION_LOCALE,
                payload: {
                    value: preferredLocale,
                    label: Utils.getLocaleNameByTag(preferredLocale)
                }
            })
        }
        const saveUserPreferredLocale = preferredLocale !== myselfLocale;
        if (saveUserPreferredLocale) {
            updateUserLocale(preferredLocale)
                .catch(() => {
                    toastr.warning("Failed saving user preferred location.")
                });
        }
    };

    static retrievePreferredLocale = (myselfLocale: any) => {
        if (myselfLocale && myselfLocale !== AuthUtils.PREFERENCE_MISSING_VALUE) {
            return myselfLocale;
        }
        const locale: { label: string, value: string } = JSON.parse(window.localStorage.getItem(Utils.LOCAL_STORAGE_ITEM_LOCALE) as string);
        return locale ? locale.value : moment.locale();
    };
}



// WEBPACK FOOTER //
// ./app/AuthUtils.ts